import { createRouter, createWebHashHistory } from "vue-router";




const routes = [

  /* 登录页面 */
  {
    path: "/login",
    component:()=>import("@/views/login/index.vue"),
    meta: { title: "登录-天利38套考试研究网" },
    children: [
      {
        path: "nowLogin",
        component:()=>import("@/views/login/nowLogin/index.vue"),
        meta: { title: "登录-天利38套考试研究网" },
      },
      {
        path: "retrievePasswordLogin",
        component:()=>import("@/views/login/retrievePasswordLogin/index.vue"),
        meta: { title: "重置密码-天利38套考试研究网" },
      },
      {
        path: "newPassword",
        component:()=>import("@/views/login/newPassword/index.vue"),
        meta: { title: "重置密码-天利38套考试研究网" },
      },
      {
        path: "QRCodeLogin",
        component:()=>import("@/views/login/QRCodeLogin/index.vue"),
      },
    ],
  },

    {
    path: "/h5test1",
    component:()=>import("@/views/h5test1/index.vue"),
    meta: { title: "注册-h1" },
  },
    {
    path: "/h5test2",
    component:()=>import("@/views/h5test2/index.vue"),
    meta: { title: "注册-h2" },
  },

  /* 注册页面  */
  {
    path: "/loginRegister",
    component:()=>import("@/views/loginRegister/index.vue"),
    meta: { title: "注册-天利38套考试研究网" },
  },
  // 微信登录
  {
    path: "/wechat",
    component:()=>import("@/views/wechat/index.vue"),
    meta: { title: "注册-天利38套考试研究网" },
  },
  {
    path: "/layout",
    component:()=>import("@/layout/index.vue"),
    children: [
      {
        path: "list",
        component:()=>import("@/list/index.vue"),
        children: [
          {
            path: "home",
            component:()=>import("@/views/home/index.vue"),
            meta: { title: "天利38套考试研究网-专注考试研究，汇集考试资源。" },
          },
          {
            path: "fundingPublicWelfareProjects",
            component:()=>import("@/views/fundingPublicWelfareProjects/index.vue"),
            meta: { title: "天利38套考试研究网-专注考试研究，汇集考试资源。" },
          },
          /*图书介绍————高中书系——初中书系——小学书系 */
          {
            path: "highSchoolBooks",
            component:()=>import("@/views/bookIntro/highSchoolBooks/index.vue"),
            meta: { title: "高中书系-图书介绍-天利38套考试研究网" },
          },
          {
            path: "middleSchoolBooks",
            component:()=>import("@/views/bookIntro/middleSchoolBooks/index.vue"),
            meta: { title: "初中书系-图书介绍-天利38套考试研究网" },
          },
          {
            path: "primarySchoolBooks",
            component:()=>import("@/views/bookIntro/primarySchoolBooks/index.vue"),
            meta: { title: "小学书系-图书介绍-天利38套考试研究网" },
          },

          /*增值服务 */
          {
            path: "addedServices",
            component:()=>import("@/views/addedServices/index.vue"),
            meta: { title: "增值服务-天利38套考试研究网" },
          },
          {
            path: "booksDetails",
            component:()=>import("@/views/addedServices/booksDetails/index.vue"),
          },

          /*精品淘题 */
          {
            path: "boutiqueTaobaoQuestions",
            component:()=>import("@/views/boutiqueTaobaoQuestions/index.vue"),
            meta: { title: "精品淘题-天利38套考试研究网" },
          },
          {
            path: "topicSubjectDetails",
            component:()=>import("@/views/boutiqueTaobaoQuestions/topicSubjectDetails/index.vue"),
          },
          {
            path: "listenBig",
            component:()=>import("@/views/boutiqueTaobaoQuestions/listenBig/index.vue"),
            meta: { title: "高级搜索-精品淘题-天利38套考试研究网" },
          },

          /*教师助手——合作平台———课题研究——教研活动——综合页面 */
          {
            path: "teacherHand",
            component:()=>import("@/views/teacherHand/index.vue"),
            meta: { title: "教师助手-天利38套考试研究网" },
          },
          //合作平台
          {
            path: "cooperatePlate",
            component:()=>import("@/views/teacherHand/cooperatePlate/index.vue"),
            meta: { title: "合作平台-教师助手-天利38套考试研究网" },
            
          },
          {
            path: "research",
            component:()=>import("@/views/teacherHand/research/index.vue"),
            meta: { title: "课题研究-教师助手-天利38套考试研究网" },
          },
          {
            path: "teachingActivities",
            component:()=>import("@/views/teacherHand/teachingActivities/index.vue"),
            meta: { title: "教研活动-教师助手-天利38套考试研究网" },
          },
          {
            path: "projectAchievements",
            component:()=>import("@/views/teacherHand/projectAchievements/index.vue"),
            meta: { title: "研究成果-教师助手-天利38套考试研究网" },
          },
          {
            path: "projectAchievementsDetails",
            component:()=>import("@/views/teacherHand/projectAchievements/projectAchievementsDetails/index.vue"),
          },

          //详情
          {
            path: "researchDetails",
            component:()=>import("@/views/teacherHand/research/researchDetails/index.vue"),
          },
          {
            path: "activityDetails",
            component:()=>import("@/views/teacherHand/teachingActivities/activityDetails/index.vue"),
          },
          {
            path: "collaborativeMediaDetails",
            component:()=>import("@/views/teacherHand/components/collaborativeMediaDetails/index.vue"),
          },
          //活动报名——教师
          {
            path: "thisEventRegistrationTeacher",
            component:()=>import("@/views/teacherHand/components/thisEventRegistrationTeacher/index.vue"),
            meta: { title: "活动报名-教师助手-天利38套考试研究网" },
          },
          //图书捐赠活动
          {
            path: "bookDonation",
            component:()=>import("@/views/teacherHand/components/bookDonation/index.vue"),
            meta: { title: "图书捐赠-教师助手-天利38套考试研究网" },
          },

          /*学生天地————知识干货——在线学习——专题活动——作品展示 */
          {
            path: "studentWorld",
            component:()=>import("@/views/studentWorld/index.vue"),
            meta: { title: "学生天地-天利38套考试研究网" },
          },
          {
            path: "studentWorldList",
            component:()=>import("@/views/studentWorld/studentWorldList/index.vue"),
            meta: { title: "搜索列表-学生天地-天利38套考试研究网" },
          },
          {
            path: "KnowledgeDrivenGoods",
            component:()=>import("@/views/studentWorld/KnowledgeDrivenGoods/index.vue"),
            meta: { title: "知识干货-学生天地-天利38套考试研究网" },
          },
          {
            path: "onlineLearning",
            component:()=>import("@/views/studentWorld/onlineLearning/index.vue"),
            meta: { title: "在线学习-学生天地-天利38套考试研究网" },
          },
          {
            path: "thematicActivities",
            component:()=>import("@/views/studentWorld/thematicActivities/index.vue"),
            meta: { title: "专题活动-学生天地-天利38套考试研究网" },
          },
          {
            path: "worksDisplay",
            component:()=>import("@/views/studentWorld/worksDisplay/index.vue"),
            meta: { title: "作品展示-学生天地-天利38套考试研究网" },
          },
          //详情
          {
            path: "KnowledgeDetails",
            component:()=>import("@/views/studentWorld/KnowledgeDrivenGoods/KnowledgeDetails/index.vue"),
          },
          {
            path: "onlineDetails",
            component:()=>import("@/views/studentWorld/onlineLearning/onlineDetails/index.vue"),
          },
          {
            path: "thematicDetails",
            component:()=>import("@/views/studentWorld/thematicActivities/thematicDetails/index.vue"),
          },
          {
            path: "worksDisplayDetails",
            component:()=>import("@/views/studentWorld/worksDisplay/worksDisplayDetails/index.vue"),
          },
          {
            path: "thisEventRegistrationStudent",
            component:()=>import("@/views/studentWorld/components/thisEventRegistrationStudent/index.vue"),
            meta: { title: "活动报名-学生天地-天利38套考试研究网" },
          },
          /*家长学堂————说政策———看流程——分数线——找大学——亲子园地 */
          {
            path: "parentSchool",
            component:()=>import("@/views/parentSchool/index.vue"),
            meta: { title: "家长学堂-天利38套考试研究网" },
          },
          {
            path: "talkPolicies",
            component:()=>import("@/views/parentSchool/talkPolicies/index.vue"),
            meta: { title: "说政策-家长学堂-天利38套考试研究网" },
          },
          {
            path: "checkTheProcess",
            component:()=>import("@/views/parentSchool/checkTheProcess/index.vue"),
            meta: { title: "看流程-家长学堂-天利38套考试研究网" },
          },
          {
            path: "checkTheProcessList",
            component:()=>import("@/views/parentSchool/checkTheProcess/checkTheProcessList/index.vue"),
            meta: { title: "搜索列表-看流程-家长学堂-天利38套考试研究网" },
          },
          {
            path: "fractionBar",
            component:()=>import("@/views/parentSchool/fractionBar/index.vue"),
            meta: { title: "分数线-家长学堂-天利38套考试研究网" },
          },
          {
            path: "findAUniversity",
            component:()=>import("@/views/parentSchool/findAUniversity/index.vue"),
            meta: { title: "找大学-家长学堂-天利38套考试研究网" },
          },
          {
            path: "parentChildGarden",
            component:()=>import("@/views/parentSchool/parentChildGarden/index.vue"),
            meta: { title: "亲子园地-家长学堂-天利38套考试研究网" },
          },
          //详情
          {
            path: "talkPoliciesDetails",
            component:()=>import("@/views/parentSchool/talkPolicies/talkPoliciesDetails/index.vue"),
          },
          {
            path: "checkTheProcessDetails",
            component:()=>import("@/views/parentSchool/checkTheProcess/checkTheProcessDetails/index.vue"),
          },
          {
            path: "findAUniversityDetails",
            component:()=>import("@/views/parentSchool/findAUniversity/findAUniversityDetails/index.vue"),
          },
          {
            path: "parentChildGardenDetails",
            component:()=>import("@/views/parentSchool/parentChildGarden/parentChildGardenDetails/index.vue"),
          },

          /*经销授权————授权网店——线下代理 */
          {
            path: "authorizedOnlineShop",
            component:()=>import("@/views/distributionAuthorization/authorizedOnlineShop/index.vue"),
            meta: { title: "授权网店-天利38套考试研究网" },

          },
          {
            path: "offlineAgent",
            component:()=>import("@/views/distributionAuthorization/offlineAgent/index.vue"),
            meta: { title: "线下代理-天利38套考试研究网" },
          },
          //详情
          {
            path: "onlineShopDetails",
            component:()=>import("@/views/distributionAuthorization/authorizedOnlineShop/onlineShopDetails/index.vue"),
          },

          //输入框步骤查询
          {
            path: "queryProgressStep",
            component:()=>import("@/views/distributionAuthorization/authorizedOnlineShop/queryProgressStep/index.vue"),
            meta: { title: "查询进度-天利38套考试研究网" },
          },

          //申请授权
          {
            path: "progressStep",
            component:()=>import("@/views/distributionAuthorization/authorizedOnlineShop/progressStep/index.vue"),
            meta: { title: "申请授权-天利38套考试研究网" },
          },

          /*关于我们 */
          {
            path: "walkIntroTianLi",
            component:()=>import("@/views/walkIntroTianLi/index.vue"),
            meta: { title: "关于我们-天利38套考试研究网" },
          },
          //详情
          {
            path: "enterpriseDetails",
            component:()=>import("@/views/walkIntroTianLi/components/enterpriseDetails/index.vue"),
          },
          {
            path: "joinUsDetails",
            component:()=>import("@/views/walkIntroTianLi/components/joinUsDetails/index.vue"),
          },

          /* 个人中心 */
          {
            path: "personalCenter",
            component:()=>import("@/views/personalCenter/index.vue"),
            meta: { title: "个人中心-天利38套考试研究网" },
            children: [
              {
                path: "personalInfor",
                component:()=>import("@/views/personalCenter/personalInfor/index.vue"), //个人信息
                meta: { title: "个人信息-个人中心-天利38套考试研究网" },
              },
              {
                path: "myBook",
                component:()=>import("@/views/personalCenter/myBook/index.vue"), //我的图书
                meta: { title: "我的图书-个人中心-天利38套考试研究网" },
              },
              {
                path: "myDownloads",
                component:()=>import("@/views/personalCenter/myDownloads/index.vue"), //我的下载
                meta: { title: "我的下载-个人中心-天利38套考试研究网" },
              },
              {
                path: "myCollection",
                component:()=>import("@/views/personalCenter/myCollection/index.vue"), //我的收藏
                meta: { title: "我的收藏-个人中心-天利38套考试研究网" },
              },
              {
                path: "myActivity",
                component:()=>import("@/views/personalCenter/myActivity/index.vue"), //我的活动
                meta: { title: "我的活动-个人中心-天利38套考试研究网" },
              },
              {
                path: "myNotifications",
                component:()=>import("@/views/personalCenter/myNotifications/index.vue"), //站内通知
                meta: { title: "站内通知-个人中心-天利38套考试研究网" },
              },

              // //我的活动—————详情
              // {
              //   path: "activityDetails",
              //   component: activityDetails,
              // },
            ],
          },
          //个人中心————站内通知————详情
          {
            path: "notificationsDetails",
            component:()=>import("@/views/personalCenter/myNotifications/notificationsDetails/index.vue"),
          },

          //个人中心————我的活动—————详情
          {
            path: "myActivityDetails",
            component:()=>import("@/views/personalCenter/myActivity/myActivityDetails/index.vue"),
          },

          //隐私政策
          {
            path: "privacyAgreement",
            component:()=>import("@/views/privacyAgreement/index.vue"),
          },

          //图书反馈-图书纠错
          {
            path: "bookCorrection",
            component:()=>import("@/views/bookCorrection/index.vue"),
            meta: { title: "图书反馈-天利38套考试研究网" },
          },

          //正版验证
          {
            path: "testAndVerify",
            component:()=>import("@/views/testAndVerify/index.vue"),
            meta: { title: "正版验证-天利38套考试研究网" },
          },
        ],
      },
    ],
  },
  // 如果没有路径的话，那么重定向到首页
  {
    path: "/",
    redirect: "/layout/list/home",
  },

  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 丝滑地滚动到顶部
    return { top: 0, behavior: "smooth" };
  },
});

//路由拦截---暂时注释
// router.beforeEach((to, from, next) => {
//   // console.log(to, from);
//   //如果已经登录
//   if (localStorage.getItem("userInfo")) {
//     if (to.path === "/login/nowLogin") {
//       next({
//         path: "/layout/list/home",
//       });
//     } else {
//       next();
//     }
//   }
//   // 如果没有登录
//   else {
//     if (to.path !== "/login/nowLogin") {
//       next({
//         path: "/login/nowLogin",
//       });
//     } else {
//       next();
//     }
//   }
// });

// 改变网站地址
function changeWebUrl(route) {
  if (
    process.env.NODE_ENV === "development" || window.location.href.includes('/h5test')
  ) {
    return;
  }
  let pcOrigin = 'https://www.tl100.com'
  let appOrigin = 'https://mobile.tl100.com'
  // 如果是手机端宽度
  if (window.document.documentElement.clientWidth<600) {
    // 如果当前网址不是手机端网址，那么就跳转到手机端网址
    if (window.location.origin !== appOrigin) {
      window.location.href = appOrigin + "/#" + route.fullPath;
    }
  }
  // 如果是电脑端宽度
  else{
    // 如果当前网址不是电脑端网址，那么就跳转到电脑端网址
    if (window.location.origin!==pcOrigin) {
      window.location.href = pcOrigin + "/#"+ route.fullPath
    }
  }
}

// 路由记录表，记录第几次进入了这个页面地址
let routerRecord = JSON.parse(localStorage.getItem("routerRecord")) ?? {};

let excludeArr = [
  "/",
  "/login/nowLogin",
  "/login/retrievePasswordLogin",
  "/login/newPassword",
  "/loginRegister",
  "/wechat",
  "/h5test1",
  "/h5test2",
];
router.beforeEach((to, from, next) => {

  // 调用函数-改变网站地址
  changeWebUrl(to);

  if (to.path === "/login/nowLogin" && !excludeArr.includes(from.path)) {
    localStorage.setItem("loginBack", from.fullPath);
  }

  // 如果对象里面存在这个属性
  if (Object.prototype.hasOwnProperty.call(routerRecord, to.path)) {
    routerRecord[to.path] = routerRecord[to.path] + 1;
  } else {
    routerRecord[to.path] = 1;
  }
  localStorage.setItem("routerRecord", JSON.stringify(routerRecord));

  next();
});
window.addEventListener("beforeunload", () => { localStorage.removeItem("routerRecord"); })

export default router;
